import { RegisterForm } from '../../../ui/Form/auth/RegisterForm';
import useQueryApiClient from '../../../utils/useQueryApiClient';
import { useNavigate } from 'react-router-dom';
import { Form, message } from 'antd';
import { useIntl } from 'react-intl';
import { LoginStyleContainer } from './LoginStyleContainer';
import PublicRoute from 'enums/publicRoutes';

export const Register = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const intl = useIntl();
  const { appendData, isLoading } = useQueryApiClient({
    request: {
      url: 'api/v2/register',
      method: 'POST',
    },
    onSuccess: (response) => {
      if (response) {
        navigate(`${PublicRoute.CONFIRMATION}?email=${form.getFieldValue('email')}`);
      }
    },
    onError: () => {
      message.error(intl.formatMessage({ id: 'message.error_email_exists' }));
    },
  });

  return (
    <LoginStyleContainer>
      <RegisterForm appendData={appendData} form={form} isLoading={isLoading} />
    </LoginStyleContainer>
  );
};
